import { useStableKeys } from 'hooks';
import { Stack } from 'libs/ui';
import { useFormContext } from 'modules/client/legal/forms/companyOrderSubmissionContactsForm';

import { Fields, Header } from './components';

interface FormContentProps {
  onRemove: (index: number) => void;
}

export const FormContent = ({ onRemove }: FormContentProps) => {
  const { values, readOnly } = useFormContext();

  const orderSubmissionContactsKeys = useStableKeys(
    values.orderSubmissionContacts
  );

  return (
    <Stack spacing={32}>
      {values.orderSubmissionContacts.map((_, index) => (
        <Stack key={orderSubmissionContactsKeys[index]} spacing={32}>
          <Stack spacing={12}>
            <Header index={index} readOnly={readOnly} onRemove={onRemove} />
            <Stack spacing={24}>
              <Fields index={index} />
            </Stack>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};
